import { Link } from "react-router-dom";
import { LinkedinLogo, GithubLogo, TwitterLogo, EnvelopeSimple } from "@phosphor-icons/react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-dark opacity-30 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3">
              <span className="relative inline-block w-9 h-9">
                <span className="absolute inset-0 bg-[#FF4F00]" />
                <span className="absolute inset-1.5 border border-white" />
                <span className="absolute top-1 left-1 w-2 h-2 bg-white" />
              </span>
              <span className="font-display text-2xl font-extrabold uppercase tracking-tight">UCUBE<span className="text-[#FF4F00]">.</span></span>
            </div>
            <p className="mt-6 text-sm text-white/60 max-w-sm leading-relaxed">
              Engineering structural software. We build, scale, and secure
              digital products for ambitious teams.
            </p>
            <p className="mt-8 text-xs font-bold uppercase tracking-[0.25em] text-white/40">/ Reach Us</p>
            <a href="mailto:contactus@ucubetechnologies.com" data-testid="footer-email-link" className="mt-2 inline-flex items-center gap-2 text-base hover:text-[#FF4F00]">
              <EnvelopeSimple size={18} /> contactus@ucubetechnologies.com
            </a>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-white/40 mb-5">/ Navigate</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" data-testid="footer-home-link" className="hover:text-[#FF4F00]">Home</Link></li>
              <li><Link to="/services" data-testid="footer-services-link" className="hover:text-[#FF4F00]">Services</Link></li>
              <li><Link to="/about" data-testid="footer-about-link" className="hover:text-[#FF4F00]">About</Link></li>
              <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-[#FF4F00]">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-white/40 mb-5">/ Legal</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-[#FF4F00]">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions" data-testid="footer-terms-link" className="hover:text-[#FF4F00]">Terms &amp; Conditions</Link></li>
              <li><Link to="/disclaimer" data-testid="footer-disclaimer-link" className="hover:text-[#FF4F00]">Disclaimer</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-white/40 mb-5">/ Offices</p>
            <ul className="space-y-4 text-sm text-white/80">
              <li>
                <p className="font-bold text-white">Pune</p>
                <p className="text-white/60">Plot No.7, Servery No. 56, Gulmohar Park, Hadapsar, MH 411028</p>
              </li>
              <li>
                <p className="font-bold text-white">UAE</p>
                <p className="text-white/60">Dubai, United Arab Emirates</p>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-6 md:items-center justify-between">
          <p className="text-xs text-white/40 uppercase tracking-[0.25em]">© {year} UCUBE Technologies — All rights reserved</p>
          <div className="flex items-center gap-4">
            <a href="#" data-testid="footer-linkedin-link" aria-label="LinkedIn" className="w-10 h-10 inline-flex items-center justify-center border border-white/20 hover:border-[#FF4F00] hover:text-[#FF4F00]"><LinkedinLogo size={18} /></a>
            <a href="#" data-testid="footer-github-link" aria-label="GitHub" className="w-10 h-10 inline-flex items-center justify-center border border-white/20 hover:border-[#FF4F00] hover:text-[#FF4F00]"><GithubLogo size={18} /></a>
            <a href="#" data-testid="footer-twitter-link" aria-label="Twitter" className="w-10 h-10 inline-flex items-center justify-center border border-white/20 hover:border-[#FF4F00] hover:text-[#FF4F00]"><TwitterLogo size={18} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
